// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".bundle." + {"355":"71bfa44ce9632b180896","494":"4e0880cf472a59eddade","980":"f7ae19fca22b318a9ad3"}[chunkId] + ".js";
};